import {InjectionToken} from '@angular/core';
import {Subject} from 'rxjs';

export const InjectedSubject = new InjectionToken<Subject<void>>('rxjs Subject as value provider');
